import React from "react";
import { addDoc, collection, Timestamp } from "firebase/firestore";
import { db, auth, storage } from "../firebaseconfig/firebase";
import { useNavigate } from "react-router-dom";
import { getDownloadURL, uploadBytes, ref } from "firebase/storage";
import { MdPublish } from "react-icons/md";



const Posts = ({ isAuth }) => {
  const navigate = useNavigate();
  const [title, setTitle] = React.useState("");
  const [postDescription, setPostDescription] = React.useState("");
  // const [shortPostDescription, setShortPostDescription] = React.useState("");
  const [thumbnail, setthumnail] = React.useState();
  const [category, setcategory] = React.useState("");
  const [publish, setPublish] = React.useState(false)
//     if (
//       title === "" ||
//       postDescription === "" ||
//       thumbnail === "" ||
//       shortPostDescription === ""
//     ) {
//       return alert("All fields must be filled");
//     }
//     uploadImage();
//   };

const addPost = async () => {
  try {
     if (
      title === "" ||
      postDescription === "" ||
      thumbnail === "" 
    ) {
      return alert("All fields must be filled");
    }
    setPublish(true);
    await uploadImage();
  } catch (error) {
    setPublish(false)
    alert("failed to upload Blog post")
  }finally{
    setPublish(false);
  }
    // if (
    //   title === "" ||
    //   postDescription === "" ||
    //   thumbnail === "" 
    // ) {
    //   return alert("All fields must be filled");
    // }
    // uploadImage();
    //setPublish(false)
  };

  // const uploadImage = async () => {
  //   if (!thumbnail) return;
  //   const imageRef = ref(storage, `blogimage/${thumbnail.name}`);
  //   uploadBytes(imageRef, thumbnail).then((snapshot) => {
  //     getDownloadURL(snapshot.ref).then((url) => {
  //       const productRef = collection(db, "Posts");
  //       try {
  //         addDoc(productRef, {
  //           title,
  //           postDescription,
  //           time: Timestamp.now(),
  //           category,
  //           thumbnail: url,
  //           // shortPostDescription,
  //           author: {
  //             name: auth.currentUser.displayName,
  //             id: auth.currentUser.uid,
  //           },
  //           date: new Date().toLocaleString("en-US", {
  //             month: "short",
  //             day: "2-digit",
  //             year: "numeric",
  //           }),
  //         });
  //         navigate("/home");
  //         alert("post addded successfully");
  //       } catch (error) {
  //         console.log(error);
  //       }
  //     });
  //   });
  // };

  const uploadImage = async () => {
  if (!thumbnail) return;

  const imageRef = ref(storage, `blogimage/${thumbnail.name}`);

  const snapshot = await uploadBytes(imageRef, thumbnail);
  const url = await getDownloadURL(snapshot.ref);

  const productRef = collection(db, "Posts");

  await addDoc(productRef, {
    title,
    postDescription,
    time: Timestamp.now(),
    category,
    thumbnail: url,
    author: {
      name: auth.currentUser.displayName,
      id: auth.currentUser.uid,
    },
    date: new Date().toLocaleString("en-US", {
      month: "short",
      day: "2-digit",
      year: "numeric",
    }),
  });

  navigate("/home");
  alert("post added successfully");
};


  React.useEffect(() => {
    if (!isAuth) {
      navigate("/");
    }
  }, [isAuth, navigate]);

  const handleSelectChange = (e) => {
    setcategory(e.target.value);
    console.log(category);
  };

  return (
    <>

      <div className="bg-blue-950 min-h-screen text-white flex flex-col lg:flex-row gap-6 p-6">
        <div className="flex flex-col gap-4 flex-1">
          <label>Post Title</label>
          <input
            className="w-full h-10 border-2 border-gray-100 rounded bg-transparent px-3"
            placeholder="Give your post a catchy title"
            onChange={(e) => {
              setTitle(e.target.value);
            }}
          />

          <label>Write your story</label>
          <textarea
            onChange={(e) => {
              setPostDescription(e.target.value);
            }}
            placeholder="Write your story"
            className="w-full h-[18rem] border-2 border-gray-300 bg-transparent p-3"
          />
        </div>

        <div className="flex flex-col gap-6 w-full lg:w-[30%]">

          <div className="border rounded bg-slate-700 p-4 text-center">
            <h5>Featured Image</h5>
            <p>Drag & drop an image or click to upload</p>
            <input
              type="file"
              onChange={(e) => setthumnail(e.target.files[0])}
              className="bg-gray-900 mt-4 w-full h-[2.5rem] rounded"
              placeholder="Upload"
            />
          </div>

          <div className="border rounded bg-gray-900 p-4">
            <p className="mb-2">Category</p>
            <select
              onChange={handleSelectChange}
              className="w-full bg-white text-black rounded p-2"
            >
              <option>Category</option>
              <option value="Technology">Technology</option>
              <option value="Culture">Culture</option>
              <option value="Art">Art</option>
              <option value="Religion">Religion</option>
              <option value="Lifestyle">Lifestyle</option>
              <option value="Fashion">Fashion</option>
              <option value="News">News</option>
              <option value="School"> School </option>
            </select>
          </div>

           <div className="border p-4 flex flex-col gap-6 rounded">
            <h5>Publish</h5>

            <div className="flex justify-between text-sm">
              <p>Auto-save is on</p>
              <p>Saved at 10:42am</p>
            </div>

            <div className="flex flex-col gap-4">
              {/* <button className="h-[40px] rounded-xl bg-gray-800">
                Save as Draft
              </button> */}
              <button
                type="button"
                onClick={addPost}
                disabled={publish}
                className="h-[40px] rounded-xl bg-blue-700"
              >
                {publish ? (
                      <div className="flex items-center justify-center text-center">
                         publishing....
                        {/* <Loader2 className="mr-2 h-4 w-4" /> publishing */}
                      </div>
                    ) : (
                      <div className="flex items-center justify-center text-center">
                        <MdPublish size="22"/> Publish Post
                      </div>
                    )}
                
              </button>
            </div>
          </div>
        </div>
      </div> 
    </>
  );
};

export default Posts;
